import {isSpainInvestmentCategory} from "../../search/hooks/use_search_param_abroad_country";
import {SpainInvestmentOfferSlug} from "../constants/investment_offer_constants";

export const getCountryDeclensionWhere = (country: SpainInvestmentOfferSlug) => {
    if (isSpainInvestmentCategory(country)) {
        return "w Hiszpanii";
    }
    return "";
};
import {isSpainInvestmentCategory} from "../../search/hooks/use_search_param_abroad_country";
import {SpainInvestmentOfferSlug} from "../constants/investment_offer_constants";

export const getCountryDeclensionWhere = (country: SpainInvestmentOfferSlug) => {
    if (isSpainInvestmentCategory(country)) {
        return "w Hiszpanii";
    }
    return "";
};
